import { styled } from 'styled-system/jsx'

const Card = styled('section', {
  base: {
    background:
      'linear-gradient(135deg, rgba(128, 84, 255, 0.95) 0%, rgba(193, 109, 255, 0.92) 100%)',
    borderRadius: 'lg',
    padding: '24px 26px',
    color: '#FFFFFF',
    boxShadow: '0 24px 60px -28px rgba(101, 56, 224, 0.55)',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    position: 'relative',
    overflow: 'hidden',
  },
})

const Eyebrow = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'rgba(255, 255, 255, 0.85)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
})

const EyebrowDot = styled('span', {
  base: {
    width: '6px',
    height: '6px',
    borderRadius: 'pill',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    display: 'inline-block',
  },
})

const Headline = styled('h3', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: '700',
    color: '#FFFFFF',
    margin: '0',
    letterSpacing: '-0.4px',
    lineHeight: '1.25',
  },
})

const Body = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.92)',
    margin: '0',
    lineHeight: '1.55',
  },
})

const Footer = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
  },
})

const CallToAction = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '700',
    color: 'quickpass.primary',
    backgroundColor: '#FFFFFF',
    border: 'none',
    borderRadius: 'pill',
    paddingX: '16px',
    paddingY: '9px',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-1px)',
      boxShadow: '0 12px 28px -10px rgba(0, 0, 0, 0.25)',
    },
  },
})

const RefreshButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'rgba(255, 255, 255, 0.85)',
    backgroundColor: 'transparent',
    border: '1px solid rgba(255, 255, 255, 0.4)',
    borderRadius: 'pill',
    paddingX: '12px',
    paddingY: '6px',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: '#FFFFFF',
      color: '#FFFFFF',
    },
    _disabled: {
      opacity: '0.5',
      cursor: 'not-allowed',
    },
  },
})

const Stamp = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'rgba(255, 255, 255, 0.7)',
    fontStyle: 'italic',
  },
})

const QuietCard = styled('section', {
  base: {
    backgroundColor: 'quickpass.surfaceCool',
    borderRadius: 'lg',
    padding: '20px 22px',
    border: '1.5px dashed',
    borderColor: '#D8D2EE',
    color: 'quickpass.inkSoft',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const QuietHeadline = styled('h3', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
  },
})

const QuietBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.5',
  },
})

const Skeleton = styled('div', {
  base: {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: 'sm',
    height: '14px',
    width: '70%',
  },
})

export {
  Card,
  Eyebrow,
  EyebrowDot,
  Headline,
  Body,
  Footer,
  CallToAction,
  RefreshButton,
  Stamp,
  QuietCard,
  QuietHeadline,
  QuietBody,
  Skeleton,
}
